<script>

	import TokenDisplay from './TokenDisplay.svelte';
	import Preview from './Preview.svelte';
	import { ui } from './stores.js';

    export let clickable = false;
    export let selectable = false;
    export let textSize = 3
    export let fakeScore = false;
	export let customStat = false;
	export let stat = false;
    export let inline = true;
	export let visible = true;
	export let showFinalScores = false;
	export let showStats = false;
	export let statSize = 3;
	export let category = '';

    let details = false;
    //console.log(state.cardsByID, id);
    export let c;

    function showDetails(){
		console.log(c);
		if($ui.selection == c){
            $ui.selection = false;
        }else{
            $ui.selection = c;
        }
    }

    function possiblyToggle(){

    }

</script>
    <button class="card {c && visible && c.suits && c.suits[0] ? c.suits[0] : ''}" class:hidden={!visible} style={"--text-size: "+textSize+"vmin;"+(inline ? " display: inline-flex; vertical-align: middle;": "")} on:click={e => { if(clickable) showDetails(); if(selectable) possiblyToggle(c); } }>
        {#if c && visible}
            {c.name}
			{#if showStats}
				{#if c.stats && c.stats.play}
					<TokenDisplay name="play" display={c.stats.play} size={statSize} />
				{/if}
				{#if c.stats && c.stats.reaction}
					<TokenDisplay name="handSize" display={c.stats.reaction} size={statSize} />
				{/if}
				{#if c.stats && c.stats.activate}
					<TokenDisplay name="activations" display={c.stats.activate} size={statSize} />
				{/if}
			{/if}
			{#if customStat}
				<div class="cardscore" style="background-color: lightblue; border-radius: 0;"><div>
					{stat}
				</div></div>
				<!--<TokenDisplay name="play" display={stat} size={statSize} />-->
            {:else if fakeScore}
                <div class="cardscore"><div>
                    {fakeScore}
                </div></div>
			{:else if c.hasOwnProperty('complete')}
				{#if c.complete && c.vp}
					<div class="cardscore"><div>{c.vp}</div></div>
				{:else}
					<div class="cardscore"><div>0</div></div>
				{/if}
			{:else if (c.score || category) && showFinalScores}
				{#if category == 'multiplier'}
						<div class="cardscore{c.stripe ? ' '+c.stripe : ''}"><div>{c.hasOwnProperty('trackScore') ? c.trackScore : (c.score || 0)}</div></div>
				{:else if category == 'conditional'}
					{#if c.goal && c.goal.includes('Endgame:')}
						<div class="cardscore endgame"><div>{c.hasOwnProperty('endGameScore') ? c.endGameScore : ((c.score || 0) - (c.vp || 0))}</div></div>
					{:else}
						<div class="cardscore"><div>{c.score}</div></div>
					{/if}
				{:else if category == 'flat'}
					<div class="cardscore"><div>{c.vp || c.score || 0}</div></div>
				{:else}
					{#if c.goal && c.goal.includes('Endgame:')}
						<div class="cardscore"><div>{c.hasOwnProperty('endGameScore') ? c.endGameScore : c.vp || 0}</div></div>
					{:else}
						<div class="cardscore"><div>{c.score}</div></div>
					{/if}
				{/if}
            {:else if c.vp}
                <div class="cardscore"><div>{c.vp}</div></div>
            {/if}
		{:else if c && !visible}
			Hidden
        {:else}
            No card
        {/if}
    </button>
<style>

.card {
		font-size: var(--text-size);
		margin: 0.5vmin;
		height: calc(2vmin + var(--text-size));
		display: flex;
		align-items: center;
		white-space: nowrap;
		cursor: pointer;
		touch-action: manipulation;
		border: 1px solid #ccc;
	}

	.card.selected {
		background-color: orange;
		color: black;
		border: 0.5vmin dashed red;
	}

	.card.hidden {
		background-color: blue;
		color: red;
	}

	.cardscore {
		font-size: var(--text-size);
		background-color: orange;
		height: var(--text-size);
		min-width: var(--text-size);
		display: flex;
		align-items: center;
		font-weight: bold;
		color: black;
		border-radius: 50%;
		border: 0.1vmin solid black;
		padding: 0.2vmin;
		margin: 0.5vmin;
		text-shadow: none;
	}

	.cardscore > div {
		text-align: center;
		width: 100%;
	}

    .triangle {
		width: 0;
		height: 0;
		border-style: solid;
		border-width: 6vmin 0 0 6vmin;
	}

	.triangle_small {
		width: 0;
		height: 0;
		border-style: solid;
		border-width: var(--text-size) 0 0 var(--text-size);
	}

	.person {
		background-color: #FCC49D;
		border: 0.5vmin solid #DB9B77;
	}
	
	.ally {
		background-color: #55C1EF;
		border: 0.5vmin solid #62A8C2;
	}
	
	.qsuit {
		background-color: hotpink;
		border: 0.5vmin solid white;
		color: white;
	}

	.ship {
		background-color: #7586C3;
		border: 0.5vmin solid #616C8D;
	}
	
	.cargo {
		background-color: #CBBDDD;
		border: 0.5vmin solid #AC92C2;
	}

	.location {
		background-color: #352239;
		color: white;
		border: 0.5vmin solid #D2BAD4;
	}

	.incident {
		background-color: #E1706A;
		border: 0.5vmin solid #E94750;
	}

	.encounter {
		background-color: #ECDAD6;
		border: 0.5vmin solid #EEC1BD;
	}

	.military {
		background-color: red;
		color: white;
	}

	.research {
		background-color: blue;
		color: white;
	}

	.influence {
		background-color: yellow;
	}

	.endgame {
		background-color: plum;
	}

</style>